<main class="px-10px xs:px-18px sm:px-30px md:px-30px md:pl-10px pb-small" [ngClass]="currentBreakpoint">
    <router-outlet></router-outlet>
</main>
<!-- Shared loading state across components, services and guards -->
@if (isLoading$ | async) {
    <app-loader></app-loader>
}
